import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { css } from '@emotion/react';
import { customProperties } from '@commercetools-uikit/design-system';
import { jsx } from '@emotion/react/jsx-runtime';

var getAlignItem = function getAlignItem(alignment) {
  switch (alignment) {
    case 'flexStart':
      return "flex-start";

    case 'flexEnd':
      return "flex-end";

    default:
      return alignment;
  }
};

var getMargin = function getMargin(scale) {
  switch (scale) {
    case 'xs':
      return customProperties.spacingXs;

    case 's':
      return customProperties.spacingS;

    case 'm':
      return customProperties.spacingM;

    case 'l':
      return customProperties.spacingL;

    case 'xl':
      return customProperties.spacingXl;

    default:
      return 0;
  }
};
/**
 * We need to force the margin for the child elements as ome children
 * might have `margin: 0` defined, which results in a higher CSS specificity,
 * causing the margings of the spacing components to be ignored.
 * See https://github.com/commercetools/ui-kit/issues/542
 */


var getStyles = function getStyles(props) {
  return /*#__PURE__*/css("display:flex;align-items:", getAlignItem(props.alignItems), ";justify-content:", props.justifyContent, ";>*+*{margin:0 0 0 ", getMargin(props.scale), "!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:getStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlubGluZS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0N3QyIsImZpbGUiOiJpbmxpbmUuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBUQWxpZ25JdGVtLCBUUHJvcHMsIFRTY2FsZSB9IGZyb20gJy4vaW5saW5lJztcblxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5cbi8vIEBUT0RPIHJlbW92ZSB0aGlzIHdoZW4gd2UgZGVwcmVjYXRlIGBmbGV4U3RhcnRgL2BmbGV4RW5kYFxuY29uc3QgZ2V0QWxpZ25JdGVtID0gKGFsaWdubWVudD86IFRBbGlnbkl0ZW0pID0+IHtcbiAgc3dpdGNoIChhbGlnbm1lbnQpIHtcbiAgICBjYXNlICdmbGV4U3RhcnQnOlxuICAgICAgcmV0dXJuIGBmbGV4LXN0YXJ0YDtcbiAgICBjYXNlICdmbGV4RW5kJzpcbiAgICAgIHJldHVybiBgZmxleC1lbmRgO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gYWxpZ25tZW50O1xuICB9XG59O1xuXG5jb25zdCBnZXRNYXJnaW4gPSAoc2NhbGU/OiBUU2NhbGUpOiBzdHJpbmcgfCBudW1iZXIgPT4ge1xuICBzd2l0Y2ggKHNjYWxlKSB7XG4gICAgY2FzZSAneHMnOlxuICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ1hzO1xuICAgIGNhc2UgJ3MnOlxuICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ1M7XG4gICAgY2FzZSAnbSc6XG4gICAgICByZXR1cm4gdmFycy5zcGFjaW5nTTtcbiAgICBjYXNlICdsJzpcbiAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdMO1xuICAgIGNhc2UgJ3hsJzpcbiAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdYbDtcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIDA7XG4gIH1cbn07XG5cbi8qKlxuICogV2UgbmVlZCB0byBmb3JjZSB0aGUgbWFyZ2luIGZvciB0aGUgY2hpbGQgZWxlbWVudHMgYXMgb21lIGNoaWxkcmVuXG4gKiBtaWdodCBoYXZlIGBtYXJnaW46IDBgIGRlZmluZWQsIHdoaWNoIHJlc3VsdHMgaW4gYSBoaWdoZXIgQ1NTIHNwZWNpZmljaXR5LFxuICogY2F1c2luZyB0aGUgbWFyZ2luZ3Mgb2YgdGhlIHNwYWNpbmcgY29tcG9uZW50cyB0byBiZSBpZ25vcmVkLlxuICogU2VlIGh0dHBzOi8vZ2l0aHViLmNvbS9jb21tZXJjZXRvb2xzL3VpLWtpdC9pc3N1ZXMvNTQyXG4gKi9cbmNvbnN0IGdldFN0eWxlcyA9IChwcm9wczogVFByb3BzKSA9PiBjc3NgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiAke2dldEFsaWduSXRlbShwcm9wcy5hbGlnbkl0ZW1zKX07XG4gIGp1c3RpZnktY29udGVudDogJHtwcm9wcy5qdXN0aWZ5Q29udGVudH07XG5cbiAgPiAqICsgKiB7XG4gICAgbWFyZ2luOiAwIDAgMCAke2dldE1hcmdpbihwcm9wcy5zY2FsZSl9ICFpbXBvcnRhbnQ7XG4gIH1cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGdldFN0eWxlcztcbiJdfQ== */");
};

var getStyles$1 = getStyles;

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Inline = function Inline(props) {
  return jsx("span", _objectSpread(_objectSpread({
    css: getStyles$1(props)
  }, filterDataAttributes(props)), {}, {
    children: props.children
  }));
};

Inline.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: _pt.oneOf(['xs', 's', 'm', 'l', 'xl']).isRequired,
  alignItems: _pt.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline', 'flexStart', 'flexEnd']).isRequired,
  justifyContent: _pt.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']).isRequired,
  children: _pt.node.isRequired
} : {};
var defaultProps = {
  scale: 's',
  alignItems: 'flex-start',
  justifyContent: 'flex-start'
};
Inline.defaultProps = defaultProps;
Inline.displayName = 'Inline';
var Inline$1 = Inline; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { Inline$1 as default, version };